module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./SicknessView.js"));
	}, "SicknessView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SicknessView!./src/pages/Shop/Member/Personal/Sickness/SicknessView.js
// module id = 1001
// module chunks = 431